export default __webpack_public_path__ + "static/media/song3.82c6cc56.jpg";